import {
  ENSURE_JSON_DOCUMENT_EXISTS,
} from "@/store/graph/types"
import { upsert }   from "@/store/graph/mutations/helpers/storeMutations"

export default {
  [ENSURE_JSON_DOCUMENT_EXISTS]: (state, action) => upsert(state, action.context.collectionName, action.response),
}
